// The pre-rendered kit agreements, as booklet-ready assets.
//
// Each PDF and its sidecar JSON are BUILD OUTPUT, not hand-written: they are
// regenerated from the legal/*.md sources by
//
//     cd apps/cid/dev && npm run render-terms:kit
//
// Round 5 (2026-09-03): one agreement per kit kind — the personal kit appends
// the Membership Agreement, the organization kit the Organization Identity
// Agreement, the delegate kit the Delegate Terms.
//
// The pages carry the letterhead artwork (full on page 1, continued stationery
// after — the agreement is a bound document, unlike the separable sheets) but
// NO page-number footer: the kit stamps its own "… — page n of N" line on them
// once it knows where in the booklet they land.
//
// terms-asset.test.ts re-hashes each markdown source and fails if it has moved
// on without the asset being re-rendered.
import membershipUrl from '../assets/legal/membership-agreement.pdf?url';
import membershipMeta from '../assets/legal/membership-agreement.json';
import organizationUrl from '../assets/legal/organization-identity-agreement.pdf?url';
import organizationMeta from '../assets/legal/organization-identity-agreement.json';
import delegateUrl from '../assets/legal/delegate-terms.pdf?url';
import delegateMeta from '../assets/legal/delegate-terms.json';

export interface TermsAsset {
    /** Resolved URL of the PDF, for fetching the bytes at print time. */
    url: string;
    /** Number of pages in the PDF — the kit needs it to number them. */
    pages: number;
    title: string;
    /** ISO date (YYYY-MM-DD) from the markdown's "**Last updated:**" line. */
    lastUpdated: string;
    /** sha256 over the source markdown bytes; drift detector, not a checksum
     *  of the PDF (Chromium output is not byte-reproducible). */
    sha256: string;
}

function asset(url: string, meta: {
    pages: number; title: string; lastUpdated: string; sha256: string;
}): TermsAsset {
    return { url, pages: meta.pages, title: meta.title, lastUpdated: meta.lastUpdated, sha256: meta.sha256 };
}

/** The Membership Agreement — the personal kit's terms. */
export const TERMS_ASSET: TermsAsset = asset(membershipUrl, membershipMeta);

/** The Organization Identity Agreement — the organization kit's terms. */
export const ORGANIZATION_TERMS_ASSET: TermsAsset = asset(organizationUrl, organizationMeta);

/** The Delegate Terms — the delegate kit's terms (founding and invited alike). */
export const DELEGATE_TERMS_ASSET: TermsAsset = asset(delegateUrl, delegateMeta);
